import React from 'react';
import { Col, Row } from 'react-bootstrap';

const fmtValor = v =>
  Number(v || 0).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

/**
 * Totalizadores — rodapé read-only (RN-15). Paridade UConsultaJudicial.pas:234-242:
 * Qtde. Contratos = nº de linhas (label6); Qtde. Parcelas = soma de `parc` (label7);
 * Valor Total = soma de `valor`, formato #,###,##0.00 (label8).
 */
const Totalizadores = ({
  qtdeContratos = 0,
  qtdeParcelas = 0,
  valorTotal = 0,
}) => (
  <Row className="mt-3">
    <Col xs="12" md="4">
      <strong>Qtde. Contratos:</strong> {Number(qtdeContratos || 0)}
    </Col>
    <Col xs="12" md="4">
      <strong>Qtde. Parcelas:</strong> {Number(qtdeParcelas || 0)}
    </Col>
    <Col xs="12" md="4">
      <strong>Valor Total:</strong> {fmtValor(valorTotal)}
    </Col>
  </Row>
);

export default Totalizadores;
